function getText(json) {
  return {
    type: "RESPONSE_LOAD_OK",
    data: json.data,
  }
}

export function LoadText() {
  return (dispatch) => {
    fetch(`/api/get-appointment-page-text`)
      .then(
        function (response) {
          if (response.status !== 200) {
            dispatch({
              type: 'REQUEST_FAIL',
              payload: {
                error_code: response.status
              }
            });
          }
          response.json().then(function (data) {
            return dispatch(getText(data));
          });
        }
      )
      .catch(function (err) {
        dispatch({
          type: 'REQUEST_FAIL',
          payload: {
            error: err
          }
        });
      });
  }
}



// WEBPACK FOOTER //
// frontend/src/actions/AppointmentPageText.js